import { createFileRoute, useSearch } from '@tanstack/react-router'
import { ProviderAuthHandler } from '@/components/ProviderAuthHandler'
import { z } from 'zod'

export const GoogleAuthErrorCode = {
  uninvitedEmail: 'uninvitedEmail',
  invalidCredentials: 'invalidCredentials',
  userNotFound: 'userNotFound',
  invalidToken: 'invalidToken',
  expiredToken: 'expiredToken',
  badRequest: 'badRequest',
} as const

const googleAuthSearchSchema = z.object({
  token: z.string().optional(),
  error: z.string().optional(),
  errorCode: z.nativeEnum(GoogleAuthErrorCode).optional(),
})

export const Route = createFileRoute('/auth/google')({
  component: () => {
    const { errorCode, error, token } = useSearch({ from: '/auth/google' })
    return <ProviderAuthHandler provider="google" errorCode={errorCode || ''} error={error || ''} token={token || ''} />
  },
  validateSearch: googleAuthSearchSchema,
})
